var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page",attrs:{"id":"app"}},[(!_vm.error)?_c('slider'):_c('h1',[_vm._v(" Вам дали неверную ссылку"),_c('br'),_vm._v("(отсутствует ID) ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }